export const resizeGdbImage = (url: string, width: number, height?: number) => {
  if (!url || !url.startsWith('https://gdb.')) {
    return url
  }

  return url.replace(
    /(\.[a-zA-Z]+)$/,
    `_w${width}${height ? `_h${height}` : ''}$1`
  )
}
